import { products, brands } from './products'
import { giftCards } from './giftCards'
import { routines } from './routines'
import { treatments } from './treatments'
import { concerns } from './concerns'
import { articles } from './articles'
import type { Catalog } from '../core/types/catalog'

/**
 * De lokale catalogus — precies de vorm die de backend straks op GET /catalog levert.
 * Zolang er geen backend is ingesteld (utils/api.ts), draait de site hierop.
 *
 * Reviews: de huidige webshop heeft er nog geen, dus de lijst is bewust leeg. De site
 * toont dan een uitnodiging in plaats van verzonnen sterren. De backend levert straks
 * alleen goedgekeurde reviews.
 */
export const localCatalog: Catalog = {
  products,
  giftCards,
  brands,
  routines,
  treatments,
  concerns,
  reviews: [],
  articles,
}
